import { render, staticRenderFns } from "./ExpenseAllocations.vue?vue&type=template&id=ba6257c2&"
import script from "./ExpenseAllocations.vue?vue&type=script&lang=js&"
export * from "./ExpenseAllocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports